import { Instagram, Mail } from "lucide-react";
import { INSTAGRAM_HANDLE, INSTAGRAM_URL, OWNER_EMAIL } from "../constants/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-[#332A24] py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <p
          data-testid="footer-brand"
          className="font-serif-display text-[13vw] font-light leading-none tracking-tight text-[#241D1A] lg:text-[9rem]"
        >
          Haus of Lash
        </p>
        <div className="mt-16 flex flex-col gap-8 border-t border-[#332A24] pt-10 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs uppercase tracking-[0.25em] text-[#A89B8F]">
            Feel pretty, look expensive.
          </p>
          <div className="flex items-center gap-8">
            <a
              data-testid="footer-email-link"
              href={`mailto:${OWNER_EMAIL}`}
              className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#A89B8F] transition-colors duration-200 hover:text-[#E6D5C3]"
            >
              <Mail size={14} strokeWidth={1.5} /> {OWNER_EMAIL}
            </a>
            <a
              data-testid="footer-instagram-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#A89B8F] transition-colors duration-200 hover:text-[#E6D5C3]"
            >
              <Instagram size={14} strokeWidth={1.5} /> {INSTAGRAM_HANDLE}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
